import axiosInstance from "../instance";

// Get All Categories
const fetchCategories = async () => {
    const response = await axiosInstance.get('/categories');
    return response.data;
}

// Add a Category
const addCategory = async (newCategory, formData) => {
    const payload = formData || newCategory;
    const response = await axiosInstance.post('/categories', payload);
    return response.data;
}

// Update Category
const updateCategory = async (editCategory) => {
    const formData = new FormData();
    formData.append('title', editCategory.title);

    if (editCategory.image instanceof File) {
        formData.append('image', editCategory.image);
    }

    const response = await axiosInstance.patch(`/categories/${editCategory.categoryId}`, formData);
    return response.data;
}

const deleteCategory = async (categoryId, url) => {
    const response = await axiosInstance.delete(`/categories/${categoryId}`);
    return response.data;
}

export { fetchCategories, addCategory, updateCategory, deleteCategory };
